import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AppsService, AuthService } from 'app/services';
import { Subject } from 'rxjs';
import { Roles } from 'app/models';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-apps-dashboard',
  templateUrl: './apps-dashboard.component.html',
  styleUrls: ['./apps-dashboard.component.scss']
})
export class AppsDashboardComponent implements OnInit, OnDestroy {
  public tabs = [{ name: 'Users', id: 0 }];
  public selectedTab;
  public roles: any[];
  public clientId: string;
  private onDestroy$ = new Subject<void>();
  rolesSub: Subject<Roles[]> = new Subject();
  user: any;
  error: string;

  constructor(
    public _appsService: AppsService,
    private route: ActivatedRoute,
    private changeDetect: ChangeDetectorRef,
    private readonly authService: AuthService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subscribeToUser();
    this.clientId = this.route.snapshot.params['client_id'];
    this.selectedTab = this.tabs[0];
    this.subscribeToRoles();
    this._appsService.getRoles(this.clientId);
  }
  onChangeTab(tabIndex) {
    this.selectedTab = this.tabs.find(t => t.id === tabIndex);
    this.changeDetect.detectChanges();
    this.rolesSub.next(this.roles);
  }
  ngOnDestroy() {
    this.onDestroy$.next(null);
  }
  subscribeToRoles(): void {
    this._appsService.appRoles$
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(roles => {
        this.roles = [];
        roles.forEach(role => {
          this.roles.push({ role: role.name, roleId: role.id });
        });
        this.rolesSub.next(this.roles);
        this.changeDetect.detectChanges();
      });
  }
  subscribeToUser() {
    this.authService.user$.subscribe(user => {
      this.user = user;
      if (this.user.isInternal) {
        this.translateService.get('Roles').subscribe(value => this.tabs.push({ name: value, id: 1 }));
      }
    });
  }
}
